(function () {
	const initProductAccordion = () => {
		$(".about__accordion-title").click(function () {
			const description = $(this).siblings(".about__accordion-description").first();

			if ($(this).hasClass("active")) {
				$(this).removeClass("active");
				description.stop().slideUp(300);
			} else {
				$(".about__accordion-title.active").removeClass("active");
				$(".about__accordion-description").stop().slideUp(300);
				$(this).addClass("active");
				description.stop().slideDown(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
